import { connect } from 'react-redux';
import { Map } from 'immutable';

import decorate from '../../../../utils/decorate';

import { request } from '../../../../modules/customers/actions/create';

import CreateAccountTab from './CreateAccountTab.jsx';

function mapStateToProps(state) {
    const search = state.customers.get('create') || Map();

    return {
        status: search.get('state'),
        errors: search.get('errors'),
        debug: search.get('debug'),
        customers: search.get('list'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onCreateRequest: (data) => dispatch(request(data))
    };
}

export default decorate(
    connect(mapStateToProps, mapDispatchToProps),
    CreateAccountTab
);
